<!--
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-13 14:16:30
 * @LastEditors: 牛字杰 niuzijie@.jtexpress
 * @LastEditTime: 2022-07-19 14:20:54
 * @FilePath: \jms-jtsd\src\pages\welfare\welfarePc.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-pc">
    <img src="https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/picWebImage.jpg" alt="" style="width: 100%;position: absolute;top: 0;left:0;opacity: 0;z-index: -999;">
    <div class="banner" :style="{backgroundImage: 'url(' + bannerImg + ')'}"></div>
    <div class="swiper">
      <template v-if="swiperImage && swiperImage.length > 0">
        <swiper :options="swiperOption" class="my-swiper">
          <swiper-slide v-for="(item, index) in swiperImage" :key="index">
            <img  class="images"  :src="item.imageUrl"/>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </template>
    </div>
    <div class="container">
      <div class="header-title">
        <img src="@/assets/img/title.png" alt="">
        <img src="@/assets/img/icon01.png" alt="">
      </div>
      <div class="input-div">
        <span class="input-title">留下信息，极兔带你领福利</span>
        <a-form-model ref="ruleForm" :rules="rules" :model="formData" class="input-modol">
          <a-form-model-item class="width50" prop="name">
            <a-input v-model.trim="formData.name" :maxLength="50" placeholder="请输入姓名">
              <div class="img-div" slot="prefix">
                <img :src="nameImg" style="width:21px;height:24px;" class="input_icon" alt="">
              </div>
            </a-input>
          </a-form-model-item>
          <a-form-model-item class="width50" prop="mobile">
            <a-input v-model.trim="formData.mobile" :maxLength="11" placeholder="请输入手机号">
              <div class="img-div" slot="prefix">
                <img :src="phoneImg" style="width:19px;height:28px;" class="input_icon" alt="">
              </div>
            </a-input>
          </a-form-model-item>
          <a-form-model-item class="width50" prop="positionSSQ">
            <a-popover placement="bottom" v-model="isShowSenderPop" trigger="click" :overlayStyle="{width:'520px'}">
                <div class="pca-pannel" slot="content">
                  <div class="pca-title">{{ pcaTitles }}</div>
                  <div class="native-name-list" v-if="addrLists && addrLists.length > 0">
                    <span
                      :title="item.nativeName"
                      class="native-name"
                      v-for="item of addrLists"
                      :key="item.id"
                      @click="addrSelecteds(item)"
                    >
                      {{ item.nativeName }}
                    </span>
                  </div>
                  <div class="flex justify-center" v-else>
                    暂无数据
                  </div>
                </div>
              <a-input v-model="formData.positionSSQ" readOnly placeholder="请选择省市区">
                <div class="img-div" slot="prefix">
                  <img :src="dizhiImg" style="width:22px;height:29px;" class="input_icon" alt="">
                </div>
              </a-input>
            </a-popover>
          </a-form-model-item>
          <a-form-model-item class="width50" prop="address">
            <a-input v-model.trim="formData.address" :maxLength="100" placeholder="请输入详细地址" />
          </a-form-model-item>
          <a-form-model-item class="width50 code" prop="captcha">
            <a-input v-model.trim="formData.captcha" :maxLength="4" placeholder="请输入图片验证码">
              <div class="img-div" slot="prefix">
                <img :src="tupianImg" style="width:23px;height:20px;" class="input_icon" alt="">
              </div>
            </a-input>
            <img class="img-code" @click="getCaptcha" :src="imgCodeUrl" alt="图片验证码">
          </a-form-model-item>
        </a-form-model>
        <div class="btn" @click="subumit">点击报名</div>
      </div>
      <div class="detail-title">
        <img src="@/assets/img/activity-title.png" alt="">
        <img src="@/assets/img/icon01.png" alt="">
      </div>
      <div class="detail-content">
        <img :src="activityDetail" alt="">
      </div>
      <div class="qr-code">
        <img src="@/assets/img/code.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
const ADDR_TYPE_PROVINCE = 2 // 省
const ADDR_TYPE_CITY = 3 // 市
const ADDR_TYPE_AREA = 4 // 区
const nameImg = require('@/assets/img/geren@2x.png')
const phoneImg = require('@/assets/img/huafei@2x.png')
const tupianImg = require('@/assets/img/tupian@2x.png')
const dizhiImg = require('@/assets/img/dizhi@2x.png')
import { SIGN_CODE_ACTIVITY } from '@constants'
import { RULES } from '@/utils/rules'
import { getAppletParams, receiveBenefit } from '@/api'
// 引入插件
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import wx from 'weixin-js-sdk'
const swiperOption = {
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  // 显示分页
  pagination: {
    el: '.swiper-pagination',
    clickable: true, // 允许分页点击跳转
  },
}
export default {
  name: 'Welfare',
  components: {
    swiper,
    swiperSlide,
  },
  metaInfo: {
    title: '电商卖家限时福利！',
    meta: [
      { name: 'description', content: '极兔福利月：免费寄100件，还有手机领' },
      {
        property: 'og:title',
        content: '电商卖家限时福利！',
        vmid: 'og:title',
      },
      {
        property: 'og:description',
        content: '极兔福利月：免费寄100件，还有手机领',
        vmid: 'og:description',
      },
      {
        property: 'og:image',
        content: 'https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/picWebImage.jpg',
        vmid: 'og:image',
      },
    ],
  },
  data() {
    return {
      nameImg,
      phoneImg,
      tupianImg,
      dizhiImg,
      swiperOption,
      formData: {
        name: '',
        mobile: '',
        address: '',
        positionSSQ: '',
        provinceName: '', // 省
        provinceId: '',
        cityName: '', // 市
        cityId: '',
        areaName: '',
        areaId: '',
        captcha: '', // 图片验证码
        source: '', // 来源
        ctoken: '',
      },
      rules: {
        name: [RULES.required],
        mobile: [RULES.required, RULES.phoneNumber],
        address: [RULES.required],
        captcha: [RULES.required],
        positionSSQ: [RULES.select],
      },
      addressList: [], // 省市区数据
      imgCodeUrl: '', // 图片验证码
      isShowSenderPop: false, // 是否显示省市区弹框
      addrTypes: ADDR_TYPE_PROVINCE,
      provinceList: {}, // 州
      cityList: {}, // 市
      areaList: {}, // 区
      bannerImg: '', // banner图
      swiperImage: [], // 轮播图
      activityDetail: '', // 活动规则
    }
  },
  computed: {
    pcaTitles() {
      const titles = {
        2: '请选择省',
        3: '请选择市',
        4: '请选择区',
      }
      return titles[this.addrTypes]
    },
    addrLists() {
      const addrs = {
        2: this.provinceList,
        3: this.cityList,
        4: this.areaList,
      }
      return addrs[this.addrTypes]
    },
  },
  watch: {
    isShowSenderPop(newV) {
      if (newV) {
        this.addrTypes = ADDR_TYPE_PROVINCE
      } else {
        this.addrTypes = ADDR_TYPE_PROVINCE
      }
    },
  },
  mounted() {
    this.getSource()
    this.getCaptcha()
    this.getAddressList(2, 1)
    this.getImgList(99)
    this.getImgList(98)
    this.getImgList(97)
    this.immediateCouponCollection()
  },
  methods: {
    get_env () { // 根据环境设置地址
      let env = ''
      switch (process.env.VUE_APP_ENV) {
        case 'prod':
          env = 'https://coupon.jtexpress.com.cn'
          break
        case 'uat':
          env = 'https://uat-coupon.jtexpress.com.cn'
          break
        case 'development':
          env = 'http://test-coupon.jms.com'
          break
        default:
          env = 'https://coupon.jtexpress.com.cn'
          break
      }
      return env
    },
    async immediateCouponCollection () {
      const env = this.get_env() // 当前环境域名
      const { source } = this.$route.query // 来源路径
      const WX_IMG_URL = 'https://pro-jms-front.oss-cn-shanghai.aliyuncs.com/baw/applets/auto/picWebImage.jpg' // 微信分享图片
      const WX_Title = '电商卖家限时福利！' // 微信分享标题
      const WX_DES = '极兔福利月：免费寄100件，还有手机领' // 微信分享描述
      const WX_LINK = `${env}/welfare?source=${source}`
      const { code, data } = await getAppletParams.getAppletParams(WX_LINK)
      if (code === 1) {
        wx.config({
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
          openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        // 通过ready接口处理成功验证
        wx.ready(function () {
          wx.updateAppMessageShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
          })
        })

        wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            link: WX_LINK,
            title: WX_Title, // 分享标题
            desc: WX_DES, // 分享描述
            imgUrl: WX_IMG_URL, // 分享图标
          })
        })

        // 通过error接口处理失败验证
        wx.error(function (res) {
          console.log(res, '通过error接口处理失败验证')
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
        })
      }
    },
    async getImgList(type) {
      const params = {
        type,
      }
      const { code, data } = await receiveBenefit.getImgList(params)
      if (code === 1) {
        switch (type) {
          case 99:
            this.bannerImg = data && data[0].imageUrl
            break
          case 98:
            this.swiperImage = data
            break
          case 97:
            this.activityDetail = data && data[0].imageUrl
            break
          default:
            break
        }
      }
    },
    getSource() {
      const { source } = this.$route.query
      this.formData.source = source
    },
    async getCaptcha() { //  获取图片验证码
      const { code, data } = await receiveBenefit.getCaptcha()
      if (code === 1) {
        this.imgCodeUrl = data.img
        this.formData.ctoken = data.ctoken
      }
    },
    async addrSelecteds(item) {
      switch (this.addrTypes) {
        case 2:
          this.formData.provinceName = item.nativeName
          this.formData.provinceId = item.id
          this.getAddressList(item.type + 1, item.id)
          break
        case 3:
          this.formData.cityName = item.nativeName
          this.formData.cityId = item.id
          this.getAddressList(item.type + 1, item.id)
          break
        case 4:
          this.formData.areaName = item.nativeName
          this.formData.areaId = item.id
          this.formData.positionSSQ = `${this.formData.provinceName} / ${this.formData.cityName} / ${this.formData.areaName}`
          this.isShowSenderPop = false
          break
      }
    },

    // 获取省市区数据
    async getAddressList(type, parentId) {
      const params = {
        type,
        parentId,
        addressType: 1,
      }
      const { code, data } = await receiveBenefit.getAddressList(params)
      if (code === 1) {
        if (type === 2) {
          this.provinceList = data
        } else if (type === 3) {
          this.addrTypes = ADDR_TYPE_CITY
          this.cityList = data
        } else if (type === 4) {
          this.addrTypes = ADDR_TYPE_AREA
          this.areaList = data
        } else {
          this.addrTypes = ADDR_TYPE_PROVINCE
          this.isShowSenderPop = false
        }
      }
    },
    clearableSSQ() {
      this.addrTypes = ADDR_TYPE_PROVINCE
      this.getAddressList(2, 1)
    },
    // 提交
    async subumit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const times = new Date().valueOf()
          const sign = this.$md5(this.$md5(this.formData.source + '' + times + SIGN_CODE_ACTIVITY))
          const params = {
            times,
            sign,
            ...this.formData,
          }
          const { code, msg } = await receiveBenefit.addReceiveBenefit(params)
          if (code === 1) {
            this.getCaptcha()
            this.$toast.success({
              message: '报名成功',
              duration: 2000,
            })
            this.resetForm()
          } else {
            this.getCaptcha()
            this.$toast.fail({
              message: msg,
              duration: 2000,
            })
          }
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
      this.formData.provinceName = ''
      this.formData.provinceId = ''
      this.formData.cityName = ''
      this.formData.cityId = ''
      this.formData.areaName = ''
      this.formData.areaId = ''
    },
  },
}
</script>
<style lang="scss">
.pca-title {
  font-size: 16px;
  font-weight: 500;
  color: #171717;
  line-height: 22px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dddddd;
  margin-bottom: 18px;
}

.native-name-list {
  display: flex;
  /*column-gap: 30px;*/
  flex-wrap: wrap;
  /*row-gap: 20px;*/
  max-height: 300px;
  overflow: auto;
  // 滚动条整体部分
  &::-webkit-scrollbar {
    width: 6px; //对垂直方向滚动条
    height: 6px; //对水平方向滚动条
  }

  //滚动的滑块
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #ccc //滚动条的颜色
  }

  //内层滚动槽
  &::-webkit-scrollbar-track-piece {
    background-color: #fff;
  }

  span {
    padding: 20px 0;
    width: 32%;
  }

  span:not(:nth-child(3n)) {
    // margin-right: 2%;
  }

  .native-name {
    width: 104px;
    text-align: center;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #171717;
    line-height: 17px;
    overflow: hidden;
    cursor: pointer;
  }

  .native-name:hover {
    color: red;
  }
}
</style>
<style lang="scss" scoped>
.banner {
  width: 100%;
  min-width: 1200px;
  height: 670px;
  // background-image: url('../../assets/img/banner.png');
  background-size: 100% 100%;
}

  ::v-deep {
    .ant-popover {
      width: 480px;
    }
  }

.swiper {
  width: 100%;
  min-width: 1200px;
  height: 410px;
  background: #ffffff;
  text-align: center;
  .my-swiper {
    padding: 47px 0 50px 0;
    box-sizing: border-box;
    .images {
      width: 1200px;
      height: 280px;
      object-fit: cover;
    }
    ::v-deep {
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border: 2px solid #EE0201;
        border-radius: 50%;
        background: #ffffff;
        opacity: 1;
      }
      .swiper-pagination-bullet-active {
        width: 10px;
        height: 10px;
        background: #EF0E0D;
        border-radius: 50%;
      }
    }
  }
}
.container {
  width: 100%;
  min-width: 1200px;
  background-image: url('../../assets/img/bg.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  text-align: center;
  padding-bottom: 93px;
  .header-title {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    img:nth-child(1) {
      margin-top: 71px;
      width: 484px;
      height: 111px;
    }
    img:nth-child(2) {
      width: 23px;
      height: 30px;
      margin: 17px 0 26px 0;
    }
  }
  .input-div {
    width: 1200px;
    margin: 0 auto;
    background: #FFFFFF;
    padding: 45px 65px 23px 65px;
    box-sizing: border-box;
    ::v-deep {
      // .el-cascader {
      //   width: 100%;
      // }
      .el-input__inner {
        padding-left: 60px;
      }
    }
    .input-title {
      width: 100%;
      display: inline-block;
      text-align: center;
      font-size: 32px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #F20101;
      line-height: 32px;
      margin-bottom: 40px;
    }
    .input-modol {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    ::v-deep {
      .ant-input {
        height: 65px;
      }
      .ant-input {
        font-size: 22px;
        padding-left: 56px;
        background: #F0F0F0;
        &::placeholder {
          font-size: 20px;
        }
      }
      .ant-input-affix-wrapper {
        border-color: #EE0201;
      }
      .ant-input-affix-wrapper:hover {
        border-color: #EE0201;
      }
      .ant-input:hover {
        border-color: #EE0201;
      }
      .ant-input:focus {
        border-color: #EE0201;
        box-shadow: 0 0 0 2px rgb(238 2 1 / 20%)
      }
      .ant-form-explain {
        text-align: left;
      }
    }
    .img-div {
      display: flex;
      align-items: center;
    }
    .input_icon {
      width: 21px;
      height: 24px;
      margin-left: 10px;
    }
    .code {
      position: relative;
      .img-code {
        position: absolute;
        top: -27px;
        right: 0;
        height: 100%;
        width: 160px;
        height: 65px;
      }
    }
    .form-info {
      display: flex;
      justify-content: space-between;
    }
    .width50 {
      width: 48%;
    }
    .width100 {
      width: 100%;
    }
    .btn {
      width: 227px;
      height: 57px;
      background: #F20000;
      border-radius: 5px;
      font-size: 32px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 57px;
      text-align: center;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .detail-title {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    img:nth-child(1) {
      margin-top: 71px;
      width: 187px;
      height: 48px;
    }
    img:nth-child(2) {
      width: 23px;
      height: 30px;
      margin: 17px 0 26px 0;
    }
  }
  .qr-code {
    margin-top: 77px;
  }
}
</style>
